<div class="header-container">
  <div class="logo-container">
    <button class="mobile-hamburger" (click)="toggleSidebar()" aria-label="Toggle menu">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </button>
    <!-- Flag on, logo + client name move into the nav panel above the product title. -->
    <a class="logo" *ngIf="!navEnabled">
      <img src="assets/images/snfai_color_transparent_bg.png" alt="SNFAI" style="width:100px;"
        (click)="logoClicked()">
    </a>
  </div>
  <div class="client-name" *ngIf="!navEnabled">{{ stagingClientName || utils.clientSettings.clientName }}</div>
  <button
    *ngIf="navEnabled"
    type="button"
    class="rail-toggle"
    [attr.aria-pressed]="railHidden$ | async"
    [attr.aria-label]="(railHidden$ | async) ? 'Show navigation' : 'Hide navigation'"
    (click)="toggleRail()">
    <lucide-icon [name]="(railHidden$ | async) ? 'PanelLeftOpen' : 'PanelLeftClose'" size="20"></lucide-icon>
  </button>
  <button type="button" class="header-brand" *ngIf="navEnabled" aria-label="Go to home screen" (click)="logoClicked()">
    <img src="assets/images/snfai_color_transparent_bg.png" alt="SNFAI">
    <span>{{ stagingClientName || utils.clientSettings.clientName }}</span>
  </button>
  <!--<nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select>-->
</div>
<div *ngIf="headerNotice$ | async as notice" class="header-notice" role="status">
  <lucide-icon class="header-notice__icon" name="info" [size]="16"></lucide-icon>
  <span>
    {{ notice.message }}
    <button class="header-notice__action" type="button" (click)="notice.action()">{{ notice.actionLabel }}</button>.
  </span>
  <button class="header-notice__close" type="button" aria-label="Dismiss" (click)="dismissNotice()">
    <lucide-icon name="x" [size]="16"></lucide-icon>
  </button>
</div>
<div #searchbar class="toolbar-slot" style="flex: 1;">
  <div>
    <ngx-search-bar></ngx-search-bar>
  </div>
</div>

<!-- Flag on, the avatar and 3-dot menu live in the nav rail, so the whole right cluster goes. -->
<div class="header-container" *ngIf="!navEnabled">
  <div class="alerts">
    <!-- <div class="bell" style="display: none;" (click)="goToPendingNAlerts()">🔔</div> -->
    <!-- <span class="pendingAlerts" *ngIf="pendingNotifications"></span> -->
    <!-- <div><img *ngIf="generalData.isProccecing && ! generalData.isLeDone " src="assets/images/loading-buffering.gif" style="width: 31px;
      margin-top: 4px;"/></div> -->

  </div>

  <!-- Flag on, the user menu moves to the nav (rail settings / drawer footer) — no avatar in the header. -->
  <nb-actions size="small" *ngIf="!navEnabled">
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user class="header-user-menu" [onlyPicture]="userPictureOnly" [name]="user?.name"
        [attr.data-letters]="user?.firstLast" [nbContextMenuTag]="tag">

      </nb-user>
    </nb-action>
  </nb-actions>
  <div class="alerts" style=" width: 26px; height: 28px;">
    <!-- <div class="bell" style="display: none;" (click)="goToPendingNAlerts()">🔔</div> -->
    <!-- <span class="pendingAlerts" *ngIf="pendingNotifications"></span> -->
    <div>
      <app-options-menu *ngIf="!navEnabled"></app-options-menu>

    </div>


  </div>